import "core-js/modules/es6.object.keys.js";
import "core-js/modules/es6.symbol.js";
import "core-js/modules/es6.array.filter.js";
import "core-js/modules/es6.object.get-own-property-descriptor.js";
import "core-js/modules/es7.object.get-own-property-descriptors.js";
import _defineProperty from "/home/runner/work/digital-chamada/digital-chamada/frontend/digital-chamada-frontend/node_modules/@babel/runtime-corejs2/helpers/defineProperty.js";
var _methods;
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import "core-js/modules/es6.number.constructor.js";
import "core-js/modules/es6.string.includes.js";
import "core-js/modules/es7.array.includes.js";
//
//
//
//
//
//

import LogService from "../services/LogService";
export default {
  name: "YouTubePlayer",
  props: {
    videoId: {
      type: String,
      default: null // ID de um vídeo único
    },

    playlistId: {
      type: String,
      default: null // ID de uma playlist
    },

    playerOptions: {
      type: Object,
      default: function _default() {
        return {
          playerVars: {
            autoplay: 1,
            controls: 0,
            modestbranding: 1,
            mute: 1,
            loop: 1
          }
        };
      }
    },
    mute: {
      type: Boolean,
      default: false
    },
    initialVolume: {
      type: Number,
      default: 100
    }
  },
  data: function data() {
    return {
      player: null,
      playerId: "youtube-player-".concat(this._uid),
      monitoringInterval: null,
      autoRestart: true,
      maxRestartAttempts: 10,
      restartAttempts: 0,
      createPlayerAttempts: 0,
      maxCreatePlayerAttempts: 10,
      createPlayerBaseDelay: 100,
      createPlayerMaxDelay: 300000,
      onReadyAttempts: 0,
      maxOnReadyAttempts: 100,
      onReadyBaseDelay: 100,
      onReadyMaxDelay: 300000,
      playerReady: false,
      isLowPowerDevice: false,
      memoryCheckInterval: null,
      lastMemoryCheck: 0,
      userInteracted: false,
      lastReloadAttempt: 0,
      reloadAttemptCount: 0
    };
  },
  mounted: function mounted() {
    var _this = this;
    this.playerReady = false;
    this.isLowPowerDevice = this.detectLowPowerDevice();
    if (!this.isYouTubeAPIReady()) {
      this.loadYouTubeAPI();
    } else {
      this.$nextTick(function () {
        _this.createPlayer();
      });
    }

    // Event listeners
    window.addEventListener('youtube-play-video', function () {
      _this.userInteracted = true;
      _this.playVideo();
    });
    window.addEventListener('youtube-pause-video', this.pauseVideo);
    window.addEventListener('youtube-mute-video', this.muteVideo);
    window.addEventListener('online', this.handleOnline);
    window.addEventListener('offline', this.pauseVideo);
  },
  methods: (_methods = {
    detectLowPowerDevice: function detectLowPowerDevice() {
      // Usa a detecção do LogService
      return LogService.isLowPowerDevice;
    },
    isYouTubeAPIReady: function isYouTubeAPIReady() {
      return window.YT && window.YT.Player && typeof window.YT.Player === 'function' && window.YT.PlayerState;
    },
    getOptimizedPlayerOptions: function getOptimizedPlayerOptions() {
      var baseOptions = _objectSpread(_objectSpread({}, this.playerOptions), {}, {
        playerVars: _objectSpread(_objectSpread({}, this.playerOptions.playerVars), {}, {
          listType: this.playlistId ? "playlist" : undefined,
          list: this.playlistId || undefined,
          rel: 0,
          showinfo: 0,
          fs: 0,
          iv_load_policy: 3
        })
      });
      if (this.isLowPowerDevice) {
        baseOptions.playerVars = _objectSpread(_objectSpread({}, baseOptions.playerVars), {}, {
          vq: 'medium'
        });
      }
      return baseOptions;
    },
    checkMemoryUsage: function checkMemoryUsage() {
      var memoryStatus = LogService.forceMemoryCheck();
      if (memoryStatus === 'HIGH_MEMORY') {
        this.forceMemoryCleanup();
      }
    },
    forceMemoryCleanup: function forceMemoryCleanup() {
      var _this2 = this;
      this.painelLog('warn', 'Iniciando limpeza de memoria...');
      if (this.monitoringInterval) {
        clearInterval(this.monitoringInterval);
        this.monitoringInterval = null;
      }
      setTimeout(function () {
        _this2.painelLog('info', 'Recarregando player apos limpeza...');
        _this2.reloadVideo();
      }, 1000);
    },
    painelLog: function painelLog() {
      var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'log';
      for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }
      LogService.save.apply(LogService, [type, 'YOUTUBE_PLAYER'].concat(args));
    },
    loadYouTubeAPI: function loadYouTubeAPI() {
      var _this3 = this;
      // Verifica se já existe uma tag script da API
      if (document.querySelector('script[src*="youtube.com/iframe_api"]')) {
        this.waitForYouTubeAPI();
        return;
      }
      var tag = document.createElement("script");
      tag.src = "https://www.youtube.com/iframe_api";
      var firstScriptTag = document.getElementsByTagName("script")[0];
      firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

      // Define o callback global apenas uma vez
      if (!window.onYouTubeIframeAPIReady) {
        window.onYouTubeIframeAPIReady = function () {
          _this3.painelLog('info', 'YouTube API carregada com sucesso');
          _this3.$nextTick(function () {
            _this3.createPlayer();
          });
        };
      }
    },
    waitForYouTubeAPI: function waitForYouTubeAPI() {
      var _this4 = this;
      var maxWaitTime = 60000; // 60 segundos
      var checkInterval = 400; // 400ms
      var waited = 0;
      var checkAPI = function checkAPI() {
        if (_this4.isYouTubeAPIReady()) {
          _this4.painelLog('info', 'YouTube API já estava carregada');
          _this4.$nextTick(function () {
            _this4.createPlayer();
          });
          return;
        }
        waited += checkInterval;
        if (waited >= maxWaitTime) {
          _this4.painelLog('error', 'Timeout aguardando YouTube API');
          // Tenta recarregar a API
          _this4.forceReloadYouTubeAPI();
          return;
        }
        setTimeout(checkAPI, checkInterval);
      };
      checkAPI();
    },
    forceReloadYouTubeAPI: function forceReloadYouTubeAPI() {
      var _this5 = this;
      // Remove scripts existentes da API
      var existingScripts = document.querySelectorAll('script[src*="youtube.com/iframe_api"]');
      existingScripts.forEach(function (script) {
        return script.remove();
      });

      // Remove o callback global
      delete window.onYouTubeIframeAPIReady;

      // Recarrega a API
      setTimeout(function () {
        _this5.loadYouTubeAPI();
      }, 1000);
    },
    createPlayer: function createPlayer() {
      var _this6 = this;
      this.playerReady = false;

      // Verifica se a API está realmente pronta
      if (!this.isYouTubeAPIReady()) {
        this.painelLog('warn', 'YouTube API não está pronta na criação. Aguardando...');
        this.waitForYouTubeAPI();
        return;
      }
      var element = document.getElementById(this.playerId);
      if (!element) {
        this.createPlayerAttempts++;
        if (this.createPlayerAttempts > this.maxCreatePlayerAttempts) {
          this.painelLog('error', 'CRITICAL: Máximo de tentativas de criação do player atingido. Abortando.');
          this.$emit('max-create-player-attempts-reached');
          return;
        }
        var delay = Math.min(this.createPlayerBaseDelay * Math.pow(2, this.createPlayerAttempts - 1), this.createPlayerMaxDelay);
        this.painelLog('warn', "Retry ".concat(this.createPlayerAttempts, "/").concat(this.maxCreatePlayerAttempts, ": Buscar elemento DOM (delay: ").concat(delay, "ms)"));
        setTimeout(function () {
          _this6.$nextTick(function () {
            return _this6.createPlayer();
          });
        }, delay);
        return;
      }
      var options = this.getOptimizedPlayerOptions();
      if (this.videoId && !this.playlistId) {
        options.videoId = this.videoId;
      }
      if (options.playerVars.loop && this.playlistId == undefined) {
        options['playerVars']['playlist'] = this.videoId;
      }
      try {
        this.painelLog('info', 'Criando player do YouTube...');
        this.player = new YT.Player(this.playerId, _objectSpread(_objectSpread({}, options), {}, {
          events: {
            onReady: this.onPlayerReady,
            onStateChange: this.onPlayerStateChange,
            onError: this.onPlayerError
          }
        }));
        this.painelLog('info', 'Player criado com sucesso');
      } catch (error) {
        this.createPlayerAttempts++;
        this.painelLog('error', 'Erro ao criar player:', error);
        if (this.createPlayerAttempts > this.maxCreatePlayerAttempts) {
          this.painelLog('error', 'CRITICAL: Máximo de tentativas de criação do player atingido por erro. Abortando.');
          this.$emit('max-create-player-attempts-reached');
          return;
        }
        if (error.message && error.message.includes('YT.Player is not a constructor')) {
          this.painelLog('warn', 'Erro de construtor - recarregando API do YouTube');
          this.forceReloadYouTubeAPI();
          return;
        }
        var _delay = Math.min(this.createPlayerBaseDelay * Math.pow(2, this.createPlayerAttempts - 1), this.createPlayerMaxDelay);
        this.painelLog('warn', "Retry ".concat(this.createPlayerAttempts, "/").concat(this.maxCreatePlayerAttempts, ": Criar player (erro) (delay: ").concat(_delay, "ms)"));
        setTimeout(function () {
          return _this6.createPlayer();
        }, _delay);
      }
    },
    onPlayerReady: function onPlayerReady(event) {
      var _this7 = this;
      this.playerReady = true;
      var playerInstance = event.target;
      var playerState = null;
      this.onReadyAttempts = (this.onReadyAttempts || 0) + 1;
      if (this.onReadyAttempts > this.maxOnReadyAttempts) {
        this.painelLog('error', 'CRITICAL: Maximo de tentativas de onPlayerReady atingido. Abortando.');
        this.$emit('max-onready-attempts-reached');
        return;
      }
      if (this.player && typeof this.player.getPlayerState === 'function') {
        try {
          playerState = this.player.getPlayerState();
        } catch (error) {
          this.painelLog('warn', 'Erro ao obter estado do player:', error);
          playerState = YT.PlayerState.UNSTARTED;
        }
      } else {
        this.painelLog('warn', 'Player não inicializado ou getPlayerState não disponível');
        playerState = YT.PlayerState.UNSTARTED;
      }
      if (this.mute) {
        playerInstance.mute();
      } else {
        playerInstance.unMute();
      }
      playerInstance.setVolume(this.initialVolume);
      if (this.userInteracted) {
        setTimeout(function () {
          if (playerState !== YT.PlayerState.PLAYING) {
            if (_this7.onReadyAttempts < _this7.maxOnReadyAttempts) {
              var delay = Math.min(_this7.onReadyBaseDelay * Math.pow(2, _this7.onReadyAttempts - 1), _this7.onReadyMaxDelay);
              _this7.painelLog('warn', "Retry ".concat(_this7.onReadyAttempts, "/").concat(_this7.maxOnReadyAttempts, ": playVideo (delay: ").concat(delay, "ms)"));
              try {
                playerInstance.playVideo();
              } catch (e) {
                _this7.reloadVideo();
              }
              setTimeout(function () {
                return _this7.onPlayerReady(event);
              }, delay);
              return;
            } else {
              _this7.painelLog('error', 'CRITICAL: Maximo de tentativas de playVideo atingido. Abortando.');
              _this7.$emit('max-onready-attempts-reached');
              return;
            }
          } else {
            _this7.onReadyAttempts = 0;
            _this7.createPlayerAttempts = 0;
            _this7.painelLog('info', "SUCCESS: Player pronto e tocando (apos ".concat(_this7.onReadyAttempts, " tentativas)"));
          }
        }, 1000);
      } else {
        // Player está pronto, mas aguarda interação do usuário
        this.painelLog('info', 'Player pronto, aguardando interação do usuário...');
        this.onReadyAttempts = 0;
        this.createPlayerAttempts = 0;
      }
      this.startMonitoring();
      this.$emit("youtube-ready", event);
    },
    onPlayerStateChange: function onPlayerStateChange(event) {
      var _stateNames;
      var state = event.data;
      var stateNames = (_stateNames = {}, _defineProperty(_stateNames, -1, 'UNSTARTED'), _defineProperty(_stateNames, 0, 'ENDED'), _defineProperty(_stateNames, 1, 'PLAYING'), _defineProperty(_stateNames, 2, 'PAUSED'), _defineProperty(_stateNames, 3, 'BUFFERING'), _defineProperty(_stateNames, 5, 'CUED'), _stateNames);
      var stateText = stateNames[state] || "UNKNOWN(".concat(state, ")");
      this.painelLog('info', "State Change: ".concat(stateText));
      if (state === YT.PlayerState.PLAYING) {
        this.restartAttempts = 0;
        this.createPlayerAttempts = 0;
        this.onReadyAttempts = 0;
        this.reloadAttemptCount = 0;
      }
      if (state === YT.PlayerState.PAUSED || state === YT.PlayerState.ENDED) {
        this.painelLog('warn', "Video parou. Estado: ".concat(stateText));
        this.handleVideoStopped(state);
      }
      this.$emit("stateChange", event);
    },
    onPlayerError: function onPlayerError(event) {
      var _this8 = this;
      this.painelLog('error', 'Erro no player do YouTube:', event.data);
      setTimeout(function () {
        _this8.safeReloadVideo("Player error: ".concat(event.data));
      }, 2000);
      this.$emit("youtube-error", event);
    },
    playVideo: function playVideo() {
      if (!this.playerReady || !this.isPlayerValid()) {
        this.painelLog('warn', 'Player não está pronto para playVideo');
        if (!this.player && this.isYouTubeAPIReady()) {
          this.createPlayer();
        }
        return;
      }
      if (!this.userInteracted) {
        this.painelLog('info', 'Aguardando interação do usuário antes de tocar...');
        return;
      }
      if (this.player && typeof this.player.playVideo === 'function') {
        try {
          this.player.playVideo();
        } catch (error) {
          this.safeReloadVideo("Erro no playVideo: ".concat(error.message || error));
        }
      } else {
        this.painelLog('warn', 'Player não válido. Recriando...');
        if (this.isYouTubeAPIReady()) {
          this.createPlayer();
        }
      }
    },
    pauseVideo: function pauseVideo() {
      if (!this.playerReady || !this.isPlayerValid()) return;
      if (this.player) {
        this.player.pauseVideo();
      }
    },
    stopVideo: function stopVideo() {
      if (!this.playerReady || !this.isPlayerValid()) return;
      if (this.player) {
        this.player.stopVideo();
      }
    },
    nextVideo: function nextVideo() {
      if (!this.playerReady || !this.isPlayerValid() || !this.playlistId) return;
      if (this.player && this.playlistId) {
        this.player.nextVideo();
      }
    },
    previousVideo: function previousVideo() {
      if (!this.playerReady || !this.isPlayerValid() || !this.playlistId) return;
      if (this.player && this.playlistId) {
        this.player.previousVideo();
      }
    },
    safeReloadVideo: function safeReloadVideo() {
      var reason = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'Erro genérico';
      if (!this.userInteracted) {
        this.painelLog('info', 'Usuário não interagiu ainda. Evitando reload desnecessário.');
        return false;
      }
      var now = Date.now();
      if (!this.lastReloadAttempt) this.lastReloadAttempt = 0;
      if (!this.reloadAttemptCount) this.reloadAttemptCount = 0;
      if (now - this.lastReloadAttempt > 120000) {
        this.reloadAttemptCount = 0;
      }
      if (this.reloadAttemptCount >= 3) {
        this.painelLog('error', 'Muitas tentativas de reload. Parando.');
        return false;
      }
      this.lastReloadAttempt = now;
      this.reloadAttemptCount++;
      this.painelLog('info', "Executando reload (".concat(this.reloadAttemptCount, "/3): ").concat(reason));
      this.reloadVideo();
      return true;
    },
    reloadVideo: function reloadVideo() {
      this.painelLog('info', 'Iniciando recarga do vídeo...');
      this.playerReady = false;
      try {
        if (this.player) {
          this.player.destroy();
          this.player = null;
        }
      } catch (error) {
        this.player = null;
      }
      if (this.monitoringInterval) {
        clearInterval(this.monitoringInterval);
        this.monitoringInterval = null;
      }
      if (!window.YT) {
        this.loadYouTubeAPI();
      } else {
        this.createPlayer();
      }
    },
    isPlayerValid: function isPlayerValid() {
      try {
        if (!this.player) return false;
        this.player.getPlayerState();
        this.player.getVideoUrl();
        return true;
      } catch (error) {
        this.painelLog('warn', 'Player não está válido:', error);
        return false;
      }
    },
    shouldReloadVideo: function shouldReloadVideo() {
      if (!this.isPlayerValid()) {
        this.painelLog('info', 'Player inválido - reload necessário');
        return true;
      }
      try {
        var currentState = this.player.getPlayerState();
        if (currentState === YT.PlayerState.PLAYING || currentState === YT.PlayerState.BUFFERING || currentState === YT.PlayerState.PAUSED) {
          return false;
        }
        this.painelLog('info', "Estado do player: ".concat(currentState, " - reload pode ser necess\xE1rio"));
        return true;
      } catch (error) {
        this.painelLog('warn', 'Erro ao verificar estado - reload necessário:', error);
        return true;
      }
    },
    handleOnline: function handleOnline() {
      if (!this.shouldReloadVideo()) {
        this.painelLog('info', 'Vídeo funcionando adequadamente. Reload desnecessário.');
        return;
      }
      this.safeReloadVideo('Conexão restaurada e vídeo não está funcionando');
    },
    startMonitoring: function startMonitoring() {
      var _this9 = this;
      if (this.monitoringInterval) {
        clearInterval(this.monitoringInterval);
      }
      var monitoringFrequency = this.isLowPowerDevice ? 10000 : 5000; // 10s para TV, 5s para outros
      this.monitoringInterval = setInterval(function () {
        if (_this9.player && _this9.autoRestart && _this9.userInteracted) {
          try {
            var currentState = _this9.player.getPlayerState();
            if (currentState !== YT.PlayerState.PLAYING && currentState !== YT.PlayerState.BUFFERING && currentState !== YT.PlayerState.PAUSED) {
              _this9.painelLog('warn', "V\xEDdeo em estado problem\xE1tico (".concat(currentState, "). Tentando reiniciar..."));
              _this9.attemptRestart();
            }
          } catch (error) {
            _this9.safeReloadVideo("Erro no startMonitoring: ".concat(error.message || error));
          }
        } else if (_this9.player && !_this9.player.getPlayerState) {
          _this9.painelLog('warn', 'Player existe mas getPlayerState não está disponível');
          _this9.safeReloadVideo('Player sem getPlayerState');
        }
        if (_this9.isLowPowerDevice) {
          _this9.checkMemoryUsage();
        }
      }, monitoringFrequency);
    },
    handleVideoStopped: function handleVideoStopped(state) {
      var _this10 = this;
      if (!this.autoRestart) return;
      setTimeout(function () {
        if (_this10.player && typeof _this10.player.getPlayerState === 'function') {
          try {
            if (_this10.player.getPlayerState() !== YT.PlayerState.PLAYING) {
              _this10.attemptRestart();
            }
          } catch (error) {
            _this10.painelLog('warn', 'Erro ao verificar estado após parada:', error);
            _this10.attemptRestart();
          }
        } else {
          _this10.painelLog('warn', 'Player não disponível após parada');
          _this10.safeReloadVideo('Player não disponível após parada');
        }
      }, 1000);
    },
    attemptRestart: function attemptRestart() {
      if (this.restartAttempts >= this.maxRestartAttempts) {
        this.painelLog('error', 'Máximo de tentativas de reinício atingido');
        this.$emit('max-restart-attempts-reached');
        return;
      }
      if (!this.userInteracted) {
        this.painelLog('info', 'Usuário ainda não interagiu. Aguardando interação para restart.');
        return;
      }
      if (!this.shouldReloadVideo()) {
        this.painelLog('info', 'Vídeo em estado normal. Restart desnecessário.');
        return;
      }
      this.restartAttempts++;
      this.painelLog('info', "Tentativa de rein\xEDcio ".concat(this.restartAttempts, "/").concat(this.maxRestartAttempts));
      if (this.isPlayerValid()) {
        try {
          this.player.playVideo();
          this.painelLog('info', 'Restart: play executado');
          return;
        } catch (error) {
          this.painelLog('warn', 'Restart: play falhou', error);
        }
      }

      // Último recurso: reload controlado
      this.safeReloadVideo('Restart falhou - necessário reload completo');
    },
    setAutoRestart: function setAutoRestart(enabled) {
      this.autoRestart = enabled;
      if (enabled) {
        this.startMonitoring();
      } else {
        this.stopMonitoring();
      }
    },
    stopMonitoring: function stopMonitoring() {
      if (this.monitoringInterval) {
        clearInterval(this.monitoringInterval);
        this.monitoringInterval = null;
      }
    },
    muteVideo: function muteVideo() {
      if (!this.playerReady || !this.isPlayerValid()) return;
      if (this.player) {
        this.player.mute();
      }
    }
  }, _defineProperty(_methods, "isPlayerValid", function isPlayerValid() {
    return this.player && typeof this.player.getPlayerState === 'function' && typeof this.player.playVideo === 'function';
  }), _defineProperty(_methods, "getPlayerStateSafe", function getPlayerStateSafe() {
    if (!this.isPlayerValid()) {
      return null;
    }
    try {
      return this.player.getPlayerState();
    } catch (error) {
      this.painelLog('warn', 'Erro ao obter estado do player:', error);
      return null;
    }
  }), _methods),
  watch: {
    videoId: function videoId(newVal) {
      if (this.playerReady && this.isPlayerValid() && this.player && !this.playlistId) {
        this.player.loadVideoById(newVal);
      }
    },
    playlistId: function playlistId(newVal) {
      if (this.playerReady && this.isPlayerValid() && this.player && newVal) {
        this.player.loadPlaylist({
          list: newVal
        });
      }
    },
    mute: function mute(newVal) {
      if (this.playerReady && this.isPlayerValid() && this.player) {
        if (newVal) {
          this.player.mute();
        } else {
          this.player.unMute();
        }
      }
    },
    initialVolume: function initialVolume(newVal) {
      if (this.playerReady && this.isPlayerValid() && this.player) {
        this.player.setVolume(newVal);
      }
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.playerReady = false;
    this.stopMonitoring();
    if (this.memoryCheckInterval) {
      clearInterval(this.memoryCheckInterval);
      this.memoryCheckInterval = null;
    }
    if (this.player) {
      this.player.destroy();
      this.player = null;
    }
    window.removeEventListener('youtube-play-video', this.playVideo);
    window.removeEventListener('youtube-pause-video', this.pauseVideo);
    window.removeEventListener('youtube-mute-video', this.muteVideo);
    window.removeEventListener('online', this.handleOnline);
    window.removeEventListener('offline', this.pauseVideo);
  }
};